import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from '../../i18n';

/* Bismillah strip at the very top of the HOME page only ("/"). Static (scrolls away),
   hidden in print. Edit the Arabic below; the tagline lives in src/locales/{en,ur}.json
   under "bismillah.tagline". To remove the strip, delete <BismillahBanner /> in src/App.js. */
export const BISMILLAH_TEXT = 'بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ';
export const BISMILLAH_ROUTE = '/';
const FONT_LINK_ID = 'zaynic-bismillah-font';
// Google Fonts "Amiri", subset (&text=) to just the Bismillah characters.
const FONT_HREF = `https://fonts.googleapis.com/css2?family=Amiri&display=swap&text=${encodeURIComponent(BISMILLAH_TEXT)}`;
const ARABIC_FONT = 'Amiri, "Traditional Arabic", "Arabic Typesetting", "Geeza Pro", "Noto Naskh Arabic", "Segoe UI", serif';

function loadFont() {
  if (typeof document === 'undefined' || document.getElementById(FONT_LINK_ID)) return;
  [['https://fonts.googleapis.com', false], ['https://fonts.gstatic.com', true]].forEach(([href, cors]) => {
    const pre = document.createElement('link');
    pre.rel = 'preconnect';
    pre.href = href;
    if (cors) pre.crossOrigin = 'anonymous';
    document.head.appendChild(pre);
  });
  const link = document.createElement('link');
  link.id = FONT_LINK_ID;
  link.rel = 'stylesheet';
  link.href = FONT_HREF;
  document.head.appendChild(link);
}

export default function BismillahBanner() {
  const { pathname } = useLocation();
  const { t, i18n } = useTranslation();
  const isHome = pathname === BISMILLAH_ROUTE;

  useEffect(() => {
    if (isHome) loadFont();
  }, [isHome]);

  if (!isHome) return null;
  const urdu = i18n.language === 'ur';

  return (
    // theme-dark forces the dark token set here, so bg-surface is charcoal in light AND dark mode.
    <div
      data-testid="bismillah-banner"
      className="theme-dark w-full overflow-hidden border-b-2 border-accent bg-surface px-4 py-3.5 text-center print:hidden sm:py-4"
    >
      <p
        lang="ar"
        dir="rtl"
        className="m-0 text-[22px] text-white sm:text-[32px]"
        style={{ fontFamily: ARABIC_FONT, lineHeight: 1.9, letterSpacing: 'normal' }}
      >
        {BISMILLAH_TEXT}
      </p>
      <p
        data-testid="bismillah-tagline"
        className={
          urdu
            ? 'm-0 mt-0.5 text-xs text-accent'
            : 'm-0 mt-1 text-[11px] font-medium uppercase leading-normal tracking-[0.25em] text-accent'
        }
      >
        {t('bismillah.tagline')}
      </p>
    </div>
  );
}
